/**
 * Mock wallets for BizPoint Phase 1 autocomplete.
 * TODO: Replace with real wallet autocomplete API when endpoint is available.
 */
export const mockWalletOptions = [
    {id: '1042', name: 'Jane Smith'},
    {id: '1088', name: 'Mike Chen'},
    {id: '1105', name: 'Sarah Lee'},
    {id: '1156', name: 'Tom Wilson'},
];
